import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getInvoices } from './../../../reducers/invoices';
import InvoicesList from '../../invoices/invoicesList';

class InvoicesTab extends React.Component {
    componentDidMount() {
        const { client, getInvoices } = this.props;
        getInvoices({ type: 'client', id: client.id });
    }

    render() {
        const { invoices } = this.props;
        if (!invoices) return null;

        return <InvoicesList invoices={invoices} role={{ type: 'client' }} canGenerateDoc={true} />;
    }
}

const mapStateToProps = state => {
    return {
        invoices: state.invoices.list
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getInvoices
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(InvoicesTab);



// WEBPACK FOOTER //
// ./src/pages/client/tabs/invoices.jsx